import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";
import { useMemo, useState } from "react";
import { usePaymentStatusManagedInOrderlink } from "../../../hooks/usePaymentStatusManagedInOrderlink";
import { UpdatePrepaymentStatusModal } from "../components/UpdatePrepaymentStatusModal";
import {
  VoidPrepaymentsModal,
  canAuthorisePrepayments,
  canMarkPrepaymentsPaid,
  canVoidPrepayments,
} from "../components/VoidPrepaymentsModal";
import { RecordPaymentModal } from "../components/RecordPaymentModal";
import { ListActionBurgerMenu } from "../../newLayout/page/components/OptionsForView/ListActionBurgerMenu";

export const PrepaymentAction = ({
  selectedOrderFromListview,
  setSelectedOrder,
  getConsignmentByRule,
}) => {
  const managedInOrderlink = usePaymentStatusManagedInOrderlink();
  const [activeModal, setActiveModal] = useState(null);
  const [isRecordPaymentOpen, setIsRecordPaymentOpen] = useState(false);

  const canVoid = useMemo(
    () => canVoidPrepayments(selectedOrderFromListview),
    [selectedOrderFromListview],
  );
  const canAuthorise = useMemo(
    () => managedInOrderlink && canAuthorisePrepayments(selectedOrderFromListview),
    [managedInOrderlink, selectedOrderFromListview],
  );
  const canMarkPaid = useMemo(
    () => managedInOrderlink && canMarkPrepaymentsPaid(selectedOrderFromListview),
    [managedInOrderlink, selectedOrderFromListview],
  );

  const handleSuccess = () => {
    getConsignmentByRule?.();
  };

  const closeModal = () => setActiveModal(null);

  const burgerItems = useMemo(() => {
    const items = [];
    if (managedInOrderlink) {
      items.push(
        {
          key: "authorise",
          label: "Authorise",
          onClick: () => setActiveModal("authorised"),
          disabled: !canAuthorise,
          title: canAuthorise ? "" : "Select prepayments eligible to authorise.",
        },
        {
          key: "mark-paid",
          label: "Mark as Paid",
          onClick: () => setActiveModal("paid"),
          disabled: !canMarkPaid,
          title: canMarkPaid ? "" : "Select authorised prepayments to mark as paid.",
        },
      );
    }
    items.push({
      key: "void",
      label: "Void",
      onClick: () => setActiveModal("void"),
      disabled: !canVoid,
      title: canVoid ? "" : "Select prepayments eligible to void.",
      isDanger: true,
    });
    return items;
  }, [managedInOrderlink, canAuthorise, canMarkPaid, canVoid]);

  return (
    <>
      {activeModal === "void" && (
        <VoidPrepaymentsModal
          closeModal={closeModal}
          prepayments={selectedOrderFromListview}
          setSelectedOrder={setSelectedOrder}
          onSuccess={handleSuccess}
        />
      )}
      {activeModal === "authorised" && (
        <UpdatePrepaymentStatusModal
          closeModal={closeModal}
          prepayments={selectedOrderFromListview}
          statusId="authorised"
          setSelectedOrder={setSelectedOrder}
          onSuccess={handleSuccess}
        />
      )}
      {activeModal === "paid" && (
        <UpdatePrepaymentStatusModal
          closeModal={closeModal}
          prepayments={selectedOrderFromListview}
          statusId="paid"
          setSelectedOrder={setSelectedOrder}
          onSuccess={handleSuccess}
        />
      )}
      {isRecordPaymentOpen && (
        <RecordPaymentModal
          isOpen={isRecordPaymentOpen}
          onClose={() => setIsRecordPaymentOpen(false)}
          onSuccess={handleSuccess}
        />
      )}
      <li className="tableButton activeState">
        <button onClick={() => setIsRecordPaymentOpen(true)}>Record Payment</button>
      </li>
      <ListActionBurgerMenu items={burgerItems} />
    </>
  );
};

export const PrepaymentActionWithCheck = componentWithCondition(PrepaymentAction);
